// Core imports
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

// Component imports
import { Result, Button } from 'antd';
import SEO from '../components/SEO/SEO';

// Misc imports
import { NAV_ROOT } from '../constants';
import NotFoundIcon from '../assets/images/not-found.png';

const PageNotFoundScreen = () => {
  const { t } = useTranslation();

  return (
    <>
      <SEO title="Page Not Found" noIndex />
      <Result
        title="404"
        className="mb-64"
        icon={<img src={NotFoundIcon} alt="Not found" style={{ maxHeight: 400 }} />}
        subTitle={t('Sorry, the page you visited does not exist.', { context: 'Message' })}
        extra={
          <Link to={NAV_ROOT}>
            <Button type="primary" className="bg-black-100 border-color-black-100 hover-bg-black-80 hover-border-color-black-80">
              {t('Return Home', { context: 'Call to action' })}
            </Button>
          </Link>
        }
      />
    </>
  );
};

export default PageNotFoundScreen;
